import { useEffect, useRef, useState } from 'react';
import { Grid, Menu, MenuProps } from 'antd';
import { TextService } from '../../Services/TextService';
import { UserOutlined, TeamOutlined, UserAddOutlined, MailOutlined, EditOutlined, FormatPainterOutlined } from '@ant-design/icons';
import { useNavigate, useParams } from 'react-router-dom';
import { getCurrentLanguage } from '../../Helpers/RouteHelper';

const LeftMenuEventDetails = (props: any) => {
    const [current, setCurrent] = useState('1');
    const GetText = TextService.GetText;
    const navigation = useNavigate();
    const param = useParams();
    // Below md the menu is above the page instead of beside it (LayoutLeftMenu).
    const isMobile = !Grid.useBreakpoint().md;
    const mobileMenuRef = useRef<HTMLDivElement>(null);
    useEffect(() => {
        setCurrent(props.selected);
    }, []);

    // The page you are on can be far to the right in the row, so it is scrolled into view.
    useEffect(() => {
        const container = mobileMenuRef.current;
        const selected = container?.querySelector<HTMLElement>(".ant-menu-item-selected, .ant-menu-submenu-selected");
        if (container && selected) {
            container.scrollLeft = selected.offsetLeft - (container.clientWidth - selected.offsetWidth) / 2;
        }
    }, [isMobile, current]);

    type MenuItem = Required<MenuProps>['items'][number];

    const onClick: MenuProps['onClick'] = (e: any) => {
        if (e.key == "myevents") {
            navigation("/" + getCurrentLanguage() + "/myevents/" + param.id);
        }

        if (e.key == "editevent") {
            navigation("/" + getCurrentLanguage() + "/myevents/" + param.id + "/edit");
        }

        if (e.key == "design") {
            navigation("/" + getCurrentLanguage() + "/myevents/" + param.id + "/design");
        }

        if (e.key == "invites") {
            navigation("/" + getCurrentLanguage() + "/myevents/" + param.id + "/invites");
        }

        if (e.key == "sendInviteGroup") {
            navigation("/" + getCurrentLanguage() + "/myevents/" + param.id + "/sendinvitegroup");
        }

        if (e.key == "sendInviteMember") {
            navigation("/" + getCurrentLanguage() + "/myevents/" + param.id + "/sendinvitemember");
        }

        if (e.key == "sendInviteExternal") {
            navigation("/" + getCurrentLanguage() + "/myevents/" + param.id + "/sendinviteexternal");
        }
    };

    function getItem(
        label: React.ReactNode,
        key?: React.Key | null,
        icon?: React.ReactNode,
        children?: MenuItem[],
        type?: 'group',
        disabled?: boolean,
        title?: string,
    ): MenuItem {
        return {
            key,
            icon,
            children,
            label,
            type,
            disabled,
            title,
        } as MenuItem;
    }
    const sendMailItems: MenuItem[] = [
        getItem(GetText("SendInvite_SendInviteGroupTitle"), 'sendInviteGroup', <TeamOutlined />),
        getItem(GetText("SendInvite_SendInviteMemberTitle"), 'sendInviteMember', <UserOutlined />),
        // An event for members only can't be answered by someone outside the register.
        getItem(GetText("SendInvite_SendInviteExternalTitle"), 'sendInviteExternal', <UserAddOutlined />, undefined, undefined,
            props.membersOnly === true, props.membersOnly === true ? GetText("SendInvite_ExternalLockedTitle") : undefined),
    ];

    const items: MenuItem[] = [
        getItem("Status & Svar", 'myevents', <TeamOutlined />),
        getItem(GetText("EventInvites_Title"), 'invites', <MailOutlined />),
        getItem(GetText("MyEventsEdit_UpdateEvent"), 'editevent', <EditOutlined />),
        getItem(GetText("EventDesign_Title"), 'design', <FormatPainterOutlined />),
        // On a phone the menu is one row, so the send pages open from a submenu instead of a group of their own.
        getItem(isMobile ? "Skicka inbjudan" : "Skicka inbjudningar e-post", 'sendInvitesHeader', <MailOutlined />, sendMailItems, isMobile ? undefined : "group"),
    ];

    // On a phone the menu above the page would fill the whole screen, so it is a row that scrolls sideways.
    if (isMobile) {
        return <div className="event-menu-mobile" ref={mobileMenuRef}>
            <Menu
                theme="light"
                onClick={onClick}
                selectedKeys={[current]}
                mode="horizontal"
                items={items}
                disabledOverflow={true}
            />
        </div>;
    }

    return <Menu
        theme="light"
        onClick={onClick}
        defaultOpenKeys={['sendInvitesHeader']}
        selectedKeys={[current]}
        inlineCollapsed={false}
        mode="inline"
        items={items}
        disabledOverflow={true}
    />
};

export default LeftMenuEventDetails;